import * as React from 'react';

import UserApi from '../modules/users/api/UserApi';
import {Form, Header, Button, Input, Breadcrumb} from 'semantic-ui-react';
import {RouteComponentProps} from 'react-router';
import Page from './Page';
import Registry from '../global/Registry';
import {Link} from 'react-router-dom';
import Duration from '../../foundation/time/Duration';
import Timepoint from '../../foundation/time/Timepoint';

interface State {
	currentPassword?: string;
	newPassword: string;
	completed: boolean;
}

export default class ChangePasswordPage extends Page<RouteComponentProps<void>, State> {

	public constructor (props: RouteComponentProps<void>) {
		super(props);

		this.state = {
			newPassword: '',
			completed: false
		};
	}

	protected isLoading () {
		return false;
	}

	protected renderTitle () {
		return 'Change your password - Brain Brooder';
	}

	protected renderDescription () {
		return 'Change your password for Brain Brooder.';
	}

	protected renderContent () {
		const sections = [{ key: 'Home', content: <Link to={'/'}>Home</Link> }, { key: 'Change your password', content: 'Change your password', active: true }];

		const singleSignInTokenLoginTimepoint = Registry.getInstance().singleSignInTokenLoginTimepoint;
		const mustProvideCurrentPassword = singleSignInTokenLoginTimepoint === undefined || !singleSignInTokenLoginTimepoint.plus(Duration.minutes(10)).isAfter(Timepoint.now());

		return (
			<div className={'lesson'}>
				<Breadcrumb icon='right angle' sections={sections} />

				<Header dividing as='h1' inverted>Change your password</Header>

				<Form inverted onSubmit={this.changePassword} style={{textAlign: 'center'}}>
					{this.state.completed ? (
						<div>
							<p style={{fontSize: '1.3em', marginTop: '32px'}}>Your password has been changed.</p>

							<Link to='/'><Button inverted style={{marginTop: '24px'}}>Continue</Button></Link>
						</div>
					) : (
						<div>
							{mustProvideCurrentPassword ?
								<Form.Field>
									<label>Current password</label>
									<Input transparent type='password' placeholder='Current password' autoFocus={mustProvideCurrentPassword} value={this.state.currentPassword} onChange={(event: any) => this.setState({currentPassword: event.target.value})}/>
								</Form.Field>
								:
								null
							}

							<Form.Field>
								<label>New password</label>
								<Input transparent type='password' placeholder='New password' autoFocus={!mustProvideCurrentPassword} value={this.state.newPassword} onChange={(event: any) => this.setState({newPassword: event.target.value})}/>
							</Form.Field>

							<Button inverted type='submit' style={{marginTop: '24px'}}>Change password</Button>
						</div>
					)}
				</Form>
			</div>
		);

		return (
			<Form inverted onSubmit={this.changePassword} style={{maxWidth: '640px', margin: 'auto'}}>
				<Header inverted as='h1' className='pageHeader'>Change your password</Header>

				{this.renderFormContent()}
			</Form>
		);
	}

	private changePassword = async (event: Event) => {
		event.preventDefault();

		await UserApi.getInstance().changePassword(this.state.newPassword, this.state.currentPassword);

		this.setState({completed: true});
	};
}


// WEBPACK FOOTER //
// ./code/project/pages/ChangePasswordPage.tsx